import React, { useEffect } from 'react'
import './style.css'
import { Col, Container, Row, Card } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import { APIINTEGRATION } from '../../../assets/images'
import ProcurementFAQ_MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer'
import AnnouncementBar from '../../../components/announcement/AnnouncementBar'

const ProcurementFAQ = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (
        <>
            {/* <AnnouncementBar  /> */}
            <Navigation />
            <Banner title="Procurement FAQ" bg={APIINTEGRATION} />

            <section className='api_intergration_section'>
                <Container className='mt-75 mb-75'>
                    <div>
                        <Row>
                            <Col lg={11}>
                                <div className='api_intergration_section_title'>
                                    <h3>
                                       Straight answers for security, legal, and commercial review—so you can move from evaluation to pilot quickly.
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </div>


                       <div className='mt-75 api_intergration_cards'>
                <ProcurementFAQ_MultiListCard  />
            </div>
                </Container>
            </section>

            <Footer />
        </>
    )
}

export default ProcurementFAQ
